var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_4075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0826 24.0698V18.1146L0.71582 13.8066L8.0826 24.0698Z",
    fill: "#F0CDC2",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10693 24.0698V18.1146L15.4737 13.8066L8.10693 24.0698Z",
    fill: "#C9B3F5",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08262 16.6346V9.03418L0.631348 12.3708L8.08262 16.6346Z",
    fill: "#88AAF1",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10693 16.6346V9.03418L15.5582 12.3708L8.10693 16.6346Z",
    fill: "#C9B3F5",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.631348 12.3706L8.0826 0.333496V9.03397L0.631348 12.3706Z",
    fill: "#F0CDC2",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5582 12.3706L8.10693 0.333496V9.03397L15.5582 12.3706Z",
    fill: "#B8FAF6",
    stroke: "#1616B4",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_4075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1648,
    height: 24,
    fill: "white",
    transform: "translate(0.499512 0.20166)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurEth);
export default __webpack_public_path__ + "static/media/cur-eth.489785ed8aec3b0b337aa1b4facde907.svg";
export { ForwardRef as ReactComponent };